import { Box, Button, Dialog, Grid, IconButton, Paper, Typography } from '@mui/material';
import { useStyles } from '../styles';
import SearchIcon from '@mui/icons-material/Search';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import KenLoader from '../../../GlobalComponents/KenLoader';
import { useNavigate } from 'react-router-dom';
import { AppButton } from '../../../Components/AppButton';
import NoFunds from '../NoFunds';
import { getFundList } from '../../../Utils/apiService';
import moment from 'moment';
import routes from '../../../Utils/routes';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const ActiveCampaigns: React.FunctionComponent = () => {
  const classes: any = useStyles();
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 600;
  const [loading, setLoading] = useState<boolean>(false);
  const [notMatchfundCampaigns, setNotMatchfundCampaigns] = useState<any[]>([]);
  const [fundCampaigns, setfundCampaigns] = useState<any[]>([]);
  const [trigger, setTrigger] = useState<number>(0);
  useEffect(() => {
    setLoading(true);
    getFundList(userData.applicantId)
      .then((res) => {
        const matchingCampaigns = res?.data?.data?.filter((val: any) => val?.Fund_Created_By__c == userData.applicantId);
        const newData = matchingCampaigns.map((element: any) => {
          const isUpcoming = moment(element?.Collection_Start_Date__c).isAfter(moment());
          const isCompleted = moment(element?.Collection_Last_Date__c).isBefore(moment());
          if (!element?.Status__c) {
            element['status'] = 'In review';
          } else {
            if (element?.Status__c === 'Approved') {
              if (isUpcoming) {
                element['status'] = 'upcoming';
              } else if (element?.Close_Campaign__c || isCompleted) {
                element['status'] = 'completed';
              } else {
                element['status'] = 'onGoing';
              }
            } else {
              element['status'] = element?.Status__c;
            }
          }

          return element;
        });
        setfundCampaigns(newData);
        const notmatchingCampaigns = res?.data?.data?.filter((val: any) => val?.Fund_Created_By__c != userData.applicantId && val?.Status__c === 'Approved');
        setNotMatchfundCampaigns(notmatchingCampaigns);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [trigger]);
  return (
    <>
      {loading && <KenLoader />}
      <Grid
        item
        xs={12}
        md={7}
        lg={9}
        xl={9}
        style={{ height: "85vh", overflowY: "auto" }}
        sx={{
          '&::-webkit-scrollbar': { display: 'none' },
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none',
        }}
      >
        <Paper className={`scrollbar-cusgray ${classes.cardContainer}`}>
          <Box className="w-100 h-100 d-flex flex-column" gap={'20px'}>
            <div className="d-flex justify-content-between align-items-center">
              <Typography className={classes.registeredEventsHeadingmobile}>Active Campaigns</Typography>

            </div>
            <div className={classes.divider} />
            {notMatchfundCampaigns.length === 0 && !loading ? (
              <NoFunds header={'No active campaigns.'} subHeader={'Please come back later.'} />
            ) : (
              <Grid container spacing={2}>
                {(notMatchfundCampaigns).map((item, index) => {
                  return (
                    <Grid item sm={12} xs={12} md={6} lg={4} xl={4} key={index} onClick={() => {
                      navigate(`${routes.fundraiseDetails}/${item.Id}`);
                    }}>
                      <div className={classes.gridItem1}>
                        <div className={classes.gridItemImage} style={{ background: `url(${item?.Fund_Category__r?.Image_URL__c})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                          <Typography className={classes.cellBanner}>{item?.Fund_Category__r?.Name || '-'}</Typography>
                        </div>
                        <div className={`${classes.gridItemContent1} scrollbar-cusgray`}>
                          <Typography className={classes.gridItemTitle1}>{item.Name}</Typography>
                          {item?.Fund_Created_By__r && (
                            <div className="d-flex align-items-center gap-3">
                              <img src={item?.Fund_Created_By__r?.Profile_Picture_URL__c} className={classes.profileImg} />
                              <Typography className={classes.profileName}>{item?.Fund_Created_By__r?.Name}</Typography>
                            </div>
                          )}
                        </div>
                        <div className={classes.gridItemFooter}>
                          <Typography className={classes.gridItemFooterText}>View Details</Typography>
                          <IconButton
                            onClick={() => {
                              navigate(`${routes.fundraiseDetails}/${item.Id}`);
                            }}
                          >
                            <ArrowForwardIcon style={{ fontSize: '18px' }} />
                          </IconButton>
                        </div>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>
        </Paper>
      </Grid>
    </>
  );
};

export default ActiveCampaigns;
